
<template>
  <div></div>
  <!-- <div v-if="isApplet">
      <van-nav-bar :title="title" :left-arrow="leftArrow" :left-text="leftText" :right-text="rightText" :fixed="fixed" @click-left="clickLeft" @click-right="clickRight" />
  </div> -->
</template>

<script>
  export default {
    name: 'headerNav', /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    props: ['title','leftArrow','leftText','rightText','fixed',],
    data() {
      return {
        octopus: this.$parent.octopus,
        isApplet: true,
      }
    },
    activated() {
      this.octopus.tools.isApplet().then(res => {
        if (res) {
          this.isApplet = false;
        }
      })
    },
    methods: {
        clickLeft() {
            this.$emit('clickLeft')
        },
        clickRight() {
            this.$emit('clickRight')
        }
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/Engine/FrameworkAPPLET/HeaderEngine.vue